import { render, staticRenderFns } from "./MatterCustomsRegistrationRenewalList.vue?vue&type=template&id=61a58f72&"
import script from "./MatterCustomsRegistrationRenewalList.vue?vue&type=script&lang=js&"
export * from "./MatterCustomsRegistrationRenewalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports